import { BreakpointObserver } from "@angular/cdk/layout";
import { registerLocaleData } from "@angular/common";
import localeNl from "@angular/common/locales/nl";
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  inject,
  signal
} from "@angular/core";
import { Title } from "@angular/platform-browser";
import {
  NavigationStart,
  Router,
  RouterModule,
  RouterOutlet
} from "@angular/router";
import { TranslocoPipe, TranslocoService } from "@jsverse/transloco";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";

import { IntroductionScreenComponent } from "./core/components/introduction-screen/introduction-screen.component";
import { SidebarStateService } from "./legacy/sidebar-state/sidebar-state.service";
import { AuthService } from "./shared/auth/auth.service";
import { RestrictedAccessHelpers } from "./shared/auth/restricted-access-helpers";
import { FullscreenLoaderComponent } from "./shared/components/fullscreen-loader/fullscreen-loader.component";
import { LocaleService } from "./shared/services/locale/locale.service";
import { ModalService } from "./shared/services/modal/modal.service";
import { SessionDataService } from "./shared/services/session-data/session-data.service";

registerLocaleData(localeNl, "nl");

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  imports: [
    IntroductionScreenComponent,
    RouterOutlet,
    RouterModule,
    FullscreenLoaderComponent,
    TranslocoPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [RestrictedAccessHelpers, ModalService]
})
export class AppComponent implements OnInit, OnDestroy {
  private titleService = inject(Title);
  private router = inject(Router);
  private breakpointObserver = inject(BreakpointObserver);
  private sidebarStateService = inject(SidebarStateService);
  private sessionData = inject(SessionDataService);

  OAuthService = inject(AuthService);
  private localeService = inject(LocaleService);
  private transloco = inject(TranslocoService);

  loggedIn = this.OAuthService.isLoggedIn;
  initialized = this.OAuthService.isInitialized;
  loginData = this.OAuthService.loginData;

  loadingMessage = signal<string | null>("Applicatie wordt geladen...");

  private profileSubscription?: Subscription;
  private chatSubscription?: Subscription;
  showWelcomeModal = false;
  showVModal = false;
  error?: string;

  constructor() {
    // Initialize language from stored preference
    this.localeService.initializeFromStorage();

    this.loadingMessage.set("Inlogstatus controleren...");
  }

  @HostListener("window:navigateToUrl", ["$event"])
  navigateToUrlEvent(event: Event) {
    this.router.navigateByUrl(
      (event as CustomEvent<{ url: string }>).detail.url
    );
  }

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((_event) => {
        this.transloco.selectTranslate("app.title").subscribe((title) => {
          this.titleService.setTitle(title);
        });
      });

    if (this.showWelcomeModal) {
      this.goToIntroduction();
    }
  }

  public ngOnDestroy(): void {
    if (this.profileSubscription) {
      this.profileSubscription.unsubscribe();
    }
    if (this.chatSubscription) {
      this.chatSubscription.unsubscribe();
    }
  }

  public goToIntroduction() {
    this.router.navigate(["/introductie", { fallbackUrl: this.router.url }]);
  }

  public openVModal() {
    this.showVModal = true;
  }

  handleCloseVPointModal() {
    this.showVModal = false;
  }
}
